import { Schema, type, MapSchema } from "@colyseus/schema";
import { TankSchema } from "./TankSchema";
import { WorldMapSchema } from "./WorldMapSchema";
import { StationSchema } from "./StationSchema";
import { PillboxSchema } from "./PillboxSchema";
import { BulletSchema } from "./BulletSchema";

// Root room state and player wrapper. Kept free of any node-only / Colyseus
// server imports so it can be bundled into the browser (online client AND the
// offline LocalRoom simulation both build this state from the same classes).

export class PlayerState extends Schema {
  @type(TankSchema) tank: TankSchema = new TankSchema();
}

export class MyRoomState extends Schema {
  @type("string") mapName: string = "Test Map";
  @type({ map: PlayerState }) players = new MapSchema<PlayerState>();
  @type(WorldMapSchema) map: WorldMapSchema = new WorldMapSchema();
  @type({ map: StationSchema }) stations = new MapSchema<StationSchema>();
  @type({ map: PillboxSchema }) pillboxes = new MapSchema<PillboxSchema>();
  @type({ map: BulletSchema }) bullets = new MapSchema<BulletSchema>();
}

// Define the newswire message interface
export interface NewswireMessage {
  type: 'player_join' | 'player_leave' | 'player_destroyed' | 'station_capture' | 'pillbox_placed' | 'pillbox_destroyed' | 'wood_harvested' | 'chat' | 'game_win' | 'info';
  playerId?: string;
  playerName?: string;
  team?: number;
  position?: { x: number, y: number };
  message: string;
  isTeamChat?: boolean;
}
